export default __webpack_public_path__ + "static/media/warning.6774f89f.svg";